import React from 'react';
import Layout from '../components/Layout';
import SalesOrderList from '../components/SalesOrderList';

const SalesOrders = () => {
  return (
    <Layout>
      <SalesOrderList />
    </Layout>
  );
};

export default SalesOrders;
